import { isDesktop } from "../MediaQuery/desktop";

export const isIOS = (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);

export const getAppStoreLogos = (logos) => {
  if (isIOS) return [logos[0]];
  return isDesktop() ? logos : [logos[1], logos[2]];
}